module.exports = __webpack_public_path__ + "static/img/b81a3f0c7fc5a85980026aeb29aa6829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MODE0-on.png
// module id = atS9
// module chunks = 1